import { render, staticRenderFns } from "./AssessmentRulesAdd.vue?vue&type=template&id=0da2b476&scoped=true"
import script from "./AssessmentRulesAdd.vue?vue&type=script&lang=js"
export * from "./AssessmentRulesAdd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2b476",
  null
  
)

export default component.exports